export default {
  events: [],
  event: {},
  entries: {},
  name: '',
  place: '',
  year: '',
  month: '',
  date: '',
  day: '',
  startHour: 0,
  startMinute: 0,
  finishHour: 1,
  finishMinute: 0,
  closeTime: 0,
  content: '',
  timezone: 'Asia/Tokyo',
  autoEntry: false,
}
